import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Icon from "../Icon";

import * as styles from "./ProjectCard.module.css";

const ProjectCard = ({ props }) => {
  const {
    backgroundImage,
    logo,
    headline,
    projectDetails,
    stat1,
    stat2,
    stat3,
  } = props;

  const backgroundImageSrc = backgroundImage && getImage(backgroundImage.file);
  const logoImageSrc = logo && getImage(logo.file);

  const checkIcon = {
    name: "fa-check",
    isSolid: true,
    size: "lg",
  };

  return (
    <div className={styles.projectCard}>
      <div className={styles.content}>
        <div>
          <h4 styles={styles.headline}>{headline}</h4>
          <div
            dangerouslySetInnerHTML={{
              __html: projectDetails.childMarkdownRemark.html,
            }}
          />
        </div>
        <div className={styles.stats}>
          <div>
            <Icon props={checkIcon} />
            {stat1}
          </div>
          <div>
            <Icon props={checkIcon} />
            {stat2}
          </div>
          <div>
            <Icon props={checkIcon} />
            {stat3}
          </div>
        </div>
      </div>
      {logo && (
        <GatsbyImage
          image={logoImageSrc}
          alt={logo.file.description}
          className={styles.logoImage}
        />
      )}
      {backgroundImage && (
        <GatsbyImage
          image={backgroundImageSrc}
          alt={backgroundImage.file.description}
          className={styles.backgroundImage}
        />
      )}
    </div>
  );
};

export default ProjectCard;
